export default __webpack_public_path__ + "static/media/email.8d003821.svg";